import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "task-image-pagination"
};
import nodata from "@/assets/img/no-data.png";
import Preview from './Preview.vue';
import ItemCard from './ItemCard.vue';
import { onMounted, onUnmounted, reactive, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import { WriteApi } from '@/api/ai/write';
export default /*@__PURE__*/_defineComponent({
  __name: 'Right',
  setup(__props, {
    expose: __expose
  }) {
    const message = useMessage(); // 消息弹窗
    // 图片分页相关的参数
    const queryParams = reactive({
      pageNo: 1,
      pageSize: 10
    });
    const pageTotal = ref(0); // page size
    const writeList = ref([]); // image 列表
    const writeListRef = ref(); // ref
    const previewContent = ref('');
    // 图片详情相关的参数
    const isShowPreview = ref(false); // 图片详情是否展示
    const showDetailId = ref(0); // 图片详情的图片编号
    /** 查看写作的详情  */
    const handlePreview = async write => {
      isShowPreview.value = true;
      previewContent.value = write.generatedContent;
    };
    /** 关闭图片的详情  */
    const handlePreviewClose = async () => {
      isShowPreview.value = false;
      previewContent.value = '';
      // 刷新列表
      await loadWriteList();
    };
    /** 获得 write列表 */
    const loadWriteList = async () => {
      const {
        list,
        total
      } = await WriteApi.getWritePage(queryParams);
      writeList.value = list;
      pageTotal.value = total;
    };
    /** 点击事件 */
    const handleItemButtonClick = async (type, writeItem) => {
      // 详情
      if (type === 'view') {
        showDetailId.value = writeItem.id;
        await handlePreview(writeItem);
        return;
      }
      // 删除
      if (type === 'delete') {
        await message.confirm(`是否删除该记录?`);
        await WriteApi.deleteWrite(writeItem.id);
        await loadWriteList();
        message.success('删除成功!');
        return;
      }
    };
    __expose({
      loadWriteList
    }); // 暴露组件方法
    /** 组件挂在的时候 */
    onMounted(async () => {
      // 获取 image 列表
      await loadWriteList();
      // // 自动刷新 image 列表
      // inProgressTimer.value = setInterval(async () => {
      //   await refreshWatchImages()
      // }, 1000 * 3)
    });
    /** 组件取消挂在的时候 */
    onUnmounted(async () => {
      // if (inProgressTimer.value) {
      //   clearInterval(inProgressTimer.value)
      // }
    });
    return (_ctx, _cache) => {
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_Pagination = _resolveComponent("Pagination");
      const _component_el_card = _resolveComponent("el-card");
      return isShowPreview.value ? (_openBlock(), _createBlock(Preview, {
        key: 0,
        ref: "previewRef",
        content: previewContent.value,
        class: "flex-grow",
        onHandleClose: handlePreviewClose
      }, null, 8, ["content"])) : (_openBlock(), _createBlock(_component_el_card, {
        key: 1,
        class: "dr-task",
        "body-class": "task-card",
        shadow: "never"
      }, {
        header: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" 写作任务 ")])),
        default: _withCtx(() => [!writeList.value.length ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: "暂无数据",
          image: _unref(nodata)
        }, null, 8, ["image"])) : _createCommentVNode("", true), _createElementVNode("div", {
          class: "task-image-list",
          ref_key: "writeListRef",
          ref: writeListRef
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(writeList.value, image => {
          return _openBlock(), _createBlock(ItemCard, {
            key: image.id,
            detail: image,
            onOnBtnClick: handleItemButtonClick
          }, null, 8, ["detail"]);
        }), 128))], 512), _createElementVNode("div", _hoisted_1, [_createVNode(_component_Pagination, {
          total: pageTotal.value,
          page: queryParams.pageNo,
          "onUpdate:page": _cache[0] || (_cache[0] = $event => queryParams.pageNo = $event),
          limit: queryParams.pageSize,
          "onUpdate:limit": _cache[1] || (_cache[1] = $event => queryParams.pageSize = $event),
          onPagination: loadWriteList
        }, null, 8, ["total", "page", "limit"])])]),
        _: 1
      }));
    };
  }
});